import { InputDecorationStateType, } from '@kubit/web-ui-components/inputDecoration/types';
const commonStateStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    container: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        display: 'flex',
        align_items: 'center',
        ...STATE_TOKENS.container,
    },
    decoration: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_comp_actions_iconbutton_secondary_default_icon,
        ...STATE_TOKENS.decoration,
    },
});
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    [InputDecorationStateType.FOCUSED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputDecorationStateType.FOCUSED] }),
    },
    [InputDecorationStateType.FILLED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputDecorationStateType.FILLED] }),
    },
    [InputDecorationStateType.EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputDecorationStateType.EMPTY] }),
    },
    [InputDecorationStateType.ERROR_EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputDecorationStateType.ERROR_EMPTY] }),
    },
    [InputDecorationStateType.ERROR_FILLED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputDecorationStateType.ERROR_FILLED] }),
    },
    [InputDecorationStateType.DISABLED_EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, {
            decoration: { color: FOUNDATIONS.color_accent_disabled_icon_100 },
            ...STATE_TOKENS[InputDecorationStateType.DISABLED_EMPTY],
        }),
    },
    [InputDecorationStateType.DISABLED_FILLED]: {
        ...commonStateStyles(FOUNDATIONS, {
            decoration: {
                color: FOUNDATIONS.color_accent_disabled_icon_50,
                ...STATE_TOKENS[InputDecorationStateType.DISABLED_FILLED].decoration,
            },
            ...STATE_TOKENS[InputDecorationStateType.DISABLED_FILLED],
        }),
    },
});
//# sourceMappingURL=commonStyles.js.map